import {
  GET_NO_APPOINTMENT_CHART,
  GET_NO_APPOINTMENT_CHART_FAIL,
  GET_NO_APPOINTMENT_CHART_SUCCESS,
  GET_CLINIC_APPOINTMENT_RATE,
  GET_CLINIC_APPOINTMENT_RATE_FAIL,
  GET_CLINIC_APPOINTMENT_RATE_SUCCESS,
  GET_PREEMPLOYMENT_RATE,
  GET_PREEMPLOYMENT_RATE_FAIL,
  GET_PREEMPLOYMENT_RATE_SUCCESS,
  GET_NO_PATIENT_RATE,
  GET_NO_PATIENT_RATE_FAIL,
  GET_NO_PATIENT_RATE_SUCCESS,
  GET_TELECONSULT_RATE,
  GET_TELECONSULT_RATE_FAIL,
  GET_TELECONSULT_RATE_SUCCESS,
  GET_ATTACHMENT,
  GET_ATTACHMENT_FAIL,
  GET_ATTACHMENT_SUCCESS,
  //excel
  GET_EXPORT_CLINIC_APPOINTMENT,
  GET_EXPORT_CLINIC_APPOINTMENT_FAIL,
  GET_EXPORT_CLINIC_APPOINTMENT_SUCCESS,
  GET_EXPORT_PREEMPLOYMENT,
  GET_EXPORT_PREEMPLOYMENT_FAIL,
  GET_EXPORT_PREEMPLOYMENT_SUCCESS,
  GET_EXPORT_TELECONSULTATION,
  GET_EXPORT_TELECONSULTATION_FAIL,
  GET_EXPORT_TELECONSULTATION_SUCCESS,
  GET_EXPORT_PATIENT,
  GET_EXPORT_PATIENT_FAIL,
  GET_EXPORT_PATIENT_SUCCESS,
  GET_EXPORT_ADMIN,
  GET_EXPORT_ADMIN_FAIL,
  GET_EXPORT_ADMIN_SUCCESS,

  RESET_DASHBOARD,
} from "./actionTypes";

//out of stock
export const getNoofAppointmentChart = () => ({
  type: GET_NO_APPOINTMENT_CHART,
});

export const getNoofAppointmentChartSuccess = general => ({
  type: GET_NO_APPOINTMENT_CHART_SUCCESS,
  payload: general,
});

export const getNoofAppointmentChartFail = error => ({
  type: GET_NO_APPOINTMENT_CHART_FAIL,
  payload: error,
});

//clinic appointment
export const getClinicAppointmentRate = () => ({
  type: GET_CLINIC_APPOINTMENT_RATE,
});

export const getClinicAppointmentRateSuccess = general => ({
  type: GET_CLINIC_APPOINTMENT_RATE_SUCCESS,
  payload: general,
});

export const getClinicAppointmentRateFail = error => ({
  type: GET_CLINIC_APPOINTMENT_RATE_FAIL,
  payload: error,
});

//maybank
export const getPreemploymentRate = () => ({
  type: GET_PREEMPLOYMENT_RATE,
});

export const getPreemploymentRateSuccess = general => ({
  type: GET_PREEMPLOYMENT_RATE_SUCCESS,
  payload: general,
});

export const getPreemploymentRateFail = error => ({
  type: GET_PREEMPLOYMENT_RATE_FAIL,
  payload: error,
});

//patient
export const getNoPatientRate = () => ({
  type: GET_NO_PATIENT_RATE,
});

export const getNoPatientRateSuccess = general => ({
  type: GET_NO_PATIENT_RATE_SUCCESS,
  payload: general,
});

export const getNoPatientRateFail = error => ({
  type: GET_NO_PATIENT_RATE_FAIL,
  payload: error,
});

//teleconsult
export const getTelecosultRate = () => ({
  type: GET_TELECONSULT_RATE,
});

export const getTelecosultRateSuccess = general => ({
  type: GET_TELECONSULT_RATE_SUCCESS,
  payload: general,
});

export const getTelecosultRateFail = error => ({
  type: GET_TELECONSULT_RATE_FAIL,
  payload: error,
});

//attch
export const getAttachment = ({ attachment }) => ({
  type: GET_ATTACHMENT,
  payload: attachment,

});

export const getAttachmentSuccess = general => ({
  type: GET_ATTACHMENT_SUCCESS,
  payload: general,
});

export const getAttachmentFail = error => ({
  type: GET_ATTACHMENT_FAIL,
  payload: error,
});


//excel
export const getExportClinicAppointment = appointment => ({
  type: GET_EXPORT_CLINIC_APPOINTMENT,
  payload: appointment,
});

export const getExportClinicAppointmentSuccess = general => ({
  type: GET_EXPORT_CLINIC_APPOINTMENT_SUCCESS,
  payload: general,
});

export const getExportClinicAppointmentFail = error => ({
  type: GET_EXPORT_CLINIC_APPOINTMENT_FAIL,
  payload: error,
});


//attch
export const getExportPreemployment = appointment => ({
  type: GET_EXPORT_PREEMPLOYMENT,
  payload: appointment,
});

export const getExportPreemploymentSuccess = general => ({
  type: GET_EXPORT_PREEMPLOYMENT_SUCCESS,
  payload: general,
});

export const getExportPreemploymentFail = error => ({
  type: GET_EXPORT_PREEMPLOYMENT_FAIL,
  payload: error,
});


//attch
export const getExportTeleconsultation = appointment => ({
  type: GET_EXPORT_TELECONSULTATION,
  payload: appointment,
});

export const getExportTeleconsultationSuccess = general => ({
  type: GET_EXPORT_TELECONSULTATION_SUCCESS,
  payload: general,
});

export const getExportTeleconsultationFail = error => ({
  type: GET_EXPORT_TELECONSULTATION_FAIL,
  payload: error,
});


//attch
export const getExportPatient = patient => ({
  type: GET_EXPORT_PATIENT,
  payload: patient,
});

export const getExportPatientSuccess = general => ({
  type: GET_EXPORT_PATIENT_SUCCESS,
  payload: general,
});

export const getExportPatientFail = error => ({
  type: GET_EXPORT_PATIENT_FAIL,
  payload: error,
});

//attch
export const getExportAdmin = admin => ({
  type: GET_EXPORT_ADMIN,
  payload: admin,

});

export const getExportAdminSuccess = general => ({
  type: GET_EXPORT_ADMIN_SUCCESS,
  payload: general,
});

export const getExportAdminFail = error => ({
  type: GET_EXPORT_ADMIN_FAIL,
  payload: error,
});


//reset
export const resetGeneralDashboard = () => {
  return {
    type: RESET_DASHBOARD,
  }
}

